module.exports = __webpack_public_path__ + "img/23-5.60ff2a45.png";